<script setup>
const props = defineProps(['items']);

const store = useEventsStore();
const activeTabByDate = computed(() => store.activeTabByDate);

const itemsRef = ref(null);
const lineStyle = ref({
  transform: 'translateX(0px)',
  width: 0,
});

const setActive = (x, width) => {
  lineStyle.value.transform = 'translateX(' + x + 'px)';
  lineStyle.value.width = width + 'px';
};

const setActiveLineWidth = () => {
  //find active tab = clicked one
  if (activeTabByDate.value != null) {
    setActive(itemsRef.value?.[activeTabByDate.value?.id]?.offsetLeft, itemsRef.value?.[activeTabByDate.value?.id]?.offsetWidth);
  } else {
    setActive(0, 0);
  }
};

const over = (event) => {
  if (event.target.className == 'tabs__button' && event.target.parentElement.className != 'dropdown__button') {
    if (event.srcElement.offsetParent.className.includes('datepicker')) {
      setActive(event.srcElement.offsetParent.offsetLeft, event.target.offsetWidth);
    } else {
      setActive(event.layerX - event.offsetX, event.target.offsetWidth);
    }
  }
};

const leave = () => {
  setActiveLineWidth();
};

watch(
  () => activeTabByDate.id,
  () => {
    setActiveLineWidth();
  }
);

let lineInterval = ref(null);

watch(
  () => props.items,
  () => {
    setTimeout(() => {
      setActiveLineWidth();
    }, 50);
  }
);

onMounted(() => {
  lineInterval = setTimeout(() => {
    setActiveLineWidth();
  }, 50);
});

onUnmounted(() => {
  clearTimeout(lineInterval);
});
</script>
<template>
  <div class="tabs">
    <div
      v-for="(item, key) in items"
      :key="key"
      ref="itemsRef"
      class="tabs__item"
      :class="{ 'tabs__item--end': item.dropdown, 'is-active': key === activeTabByDate?.id }"
      @mouseover="over"
      @mouseleave="leave"
    >
      <TabDropdown v-if="item.dropdown" :id="key" :text="item.name" :items="item.dropdown" />
      <div v-else-if="item.datepicker">
        <DatePicker :id="key" :item="item"></DatePicker>
      </div>
      <TabButton v-else :id="key" :item="item" />
    </div>
    <div class="tabs__line" :style="lineStyle"></div>
  </div>
</template>

<style lang="scss" scoped>
@use '@scss/generic/forms/button.scss';

.tabs {
  $s: &;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-items: self-end;

  @include mq($md) {
    border-bottom: 1px solid $black;
  }

  &__line {
    background: $black;
    bottom: 0;
    display: none;
    left: 0;
    height: 2px;
    position: absolute;
    transition:
      transform 300ms,
      width 300ms;
    width: 0;

    @include mq($md) {
      display: block;
    }
  }

  &__item {
    margin-right: 25px;

    @include mq($xxl) {
      margin-right: 50px;
    }

    &--end {
      margin-left: auto;
      margin-right: 0;
    }
  }

  &__button {
    @include button-reset;
    padding: 10px 0;
    text-transform: uppercase;
    cursor: pointer;
    outline: none;
    background: linear-gradient(to top, $black 0%, $black 100%) center bottom no-repeat;
    background-size: 100% 0px;
    //transition: font-weight 300ms;
    white-space: nowrap;

    &:before {
      display: block;
      content: attr(data-text);
      font-weight: $font-weight-medium;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }

    &:hover {
      //font-weight: $font-weight-medium;
    }

    &:focus {
      outline: none;
      //background-size: 100% 1px;
    }

    #{$s}__item.is-active & {
      font-weight: $font-weight-medium;
      //background-size: 100% 2px;

      /*
            #{$s}__arrow {
                transform: rotate(180deg);
            }
            */
    }
  }

  &__border {
    @extend .button;
    @extend .button--small;
    @extend .button--normal;
    @extend .button--transparent;

    #{$s}__arrow {
      border-width: 4px;
      border-bottom-width: 0;
      margin-left: 8px;
    }
  }

  &__arrow {
    @include triangle(currentColor, down, 5px);
    display: inline-block;
    vertical-align: middle;
    transition: transform 300ms;
  }
}
</style>
